const TEST_RESULT_DUMMY_URL = 'https://testlink_empty.com';

export { TEST_RESULT_DUMMY_URL };
